export var addEventListenerLive = function (eventType, elementQuerySelector, cb, rootElement) {
    if (rootElement === void 0) { rootElement = null; }
    var element = rootElement ? rootElement : document;
    element.addEventListener(eventType, function (event) {
        var qs = document.querySelectorAll(elementQuerySelector);
        if (qs) {
            var element = event.target, index = -1;
            while (element && ((index = Array.prototype.indexOf.call(qs, element)) === -1)) {
                element = element.parentElement;
            }
            if (index > -1) {
                cb.call(element, event);
            }
        }
    });
};
